import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';

const prepareGetResponse = <T extends {}>(response: Response) => {
    if (response.ok) {
        return response.json() as Promise<T>;
    }
    throw new Error(response.statusText);
};

const pepareDeleteResponse = (response: Response): void => {
    if (!response.ok || response.status !== 204) {
        throw new Error(response.statusText);
    }
};

const preparePostResponse = async (response: Response) => {
    const contentType = response.headers.get('content-type');
    const isJsonContentType = contentType?.includes('application/json');

    if (response.ok || response.status === 201) {
        return response.text();
    }

    if (response.status === 400) {
        if (isJsonContentType) {
            const error = await response.json();
            throw new Error(error);
        } else {
            const error = await response.text();
            throw new Error(error);
        }
    }

    throw new Error(response.statusText);
};

export const getRequest = <T extends {}>(
    authService: IAuthServiceV2,
    resourceHostId: string,
    url: string,
    headers?: any,
): Promise<any> => authService.get(resourceHostId, url, headers)
    .then((response) => prepareGetResponse<T>(response));

export const deleteRequest = (
    authService: IAuthServiceV2,
    resourceHostId: string,
    url: string,
    headers?: any,
): Promise<any> => authService.delete(resourceHostId, url, headers)
    .then((response) => pepareDeleteResponse(response));

export const postRequest = async (
    authService: IAuthServiceV2,
    resourceHostId: string,
    url: string,
    payload: any,
    headers: any,
): Promise<any> => {
    const response = await authService.post(resourceHostId, url, JSON.stringify(payload), headers);
    return preparePostResponse(response);
}

